import { render } from "./Server.vue?vue&type=template&id=229af7bc&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"

import "./Server.vue?vue&type=style&index=0&id=229af7bc&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229af7bc"]])

export default __exports__